import type { GraphicsBlockerLike, GraphicsRuntimeError } from '../composables/useGraphicsBackendState'

/**
 * 把引擎抛出的图形错误归一为控制卡可展示的运行时错误。
 *
 * `GraphicsRequirementsError` 的结构化 `issues` 会被保留下来，供卡片按主体展示阻塞项；
 * 其它错误只保留消息，避免把任意异常伪装成结构化阻塞。
 */
export function toGraphicsRuntimeError(error: unknown): GraphicsRuntimeError {
  if (!(error instanceof Error)) {
    return { message: String(error) }
  }

  const issues = (error as { issues?: unknown }).issues
  if (Array.isArray(issues) && issues.length > 0) {
    return { message: error.message, blockers: issues as readonly GraphicsBlockerLike[] }
  }

  return { message: error.message }
}
